<section class="footer-contacts">
  <div class="footer-contacts__item">
    <a href="tel:154" class="footer-contacts__tel eye-hover">
      <div
        [inlineSVG]="'../assets/img/misc/tel-154.svg'"
        aria-label="154"
      ></div>
    </a>
    <div class="footer-contacts__mobile">
      <div class="block">
        <div class="phone-title-block">
          <div class="phone-title">
            {{ 'CONTACTS.PHONE_OPERATOR_NAME_ONE' | translate }}
          </div>
          <div class="phone-title">
            {{ 'CONTACTS.PHONE_OPERATOR_NAME_TWO' | translate }}
          </div>
        </div>
        <div>
          <div>
            <a
              href="tel:{{
                'CONTACTS.PHONE_NUMBER_ONE_WITHOUT_SPACE' | translate
              }}"
              class="phone-item"
            >
              {{ 'CONTACTS.PHONE_NUMBER_ONE' | translate }}
            </a>
          </div>
          <div>
            <a
              href="tel:{{
                'CONTACTS.PHONE_NUMBER_TWO_WITHOUT_SPACE' | translate
              }}"
              class="phone-item"
            >
              {{ 'CONTACTS.PHONE_NUMBER_TWO' | translate }}
            </a>
          </div>
        </div>
      </div>

      <div class="phone-row-info">{{ 'CONTACTS.PHONE_INFO' | translate }}</div>
    </div>
    <p
      class="footer-contacts__text"
      [innerHTML]="'FOOTER_WORK_SHEDULE' | translate"
    ></p>
  </div>
  <div class="footer-contacts__item">
    <p
      class="footer-contacts__text"
      [innerHTML]="'FOOTER_CONTACTS' | translate"
    ></p>
  </div>
  <div class="footer-contacts__item">
    <iframe
      src="https://xn----7sbgfh2alwzdhpc0c.xn--90ais/widget?pan=101015738"
      title="Качество услуг"
      width="300"
      height="130"
      frameborder="0"
      scrolling="no"
    ></iframe>
  </div>
  <p class="footer-contacts__text">{{ 'FOOTER_LICENSE' | translate }}</p>
</section>
